//
// axios.js
//

import axios from 'axios';

// Make available globally
window.axios = axios;